import {Widget} from '@acng/frontend-stargazer';
import {query, queryAll} from '@acng/frontend-bounty/query';
import {InputEvent, TAGNAME_INPUT} from '@acng/frontend-bounty/types';
import {on, EVENT_INPUT, EVENT_KEYDOWN} from '@acng/frontend-bounty/event';

import {coreFeature} from '../config/feature.js';

/**
 * @typedef {HTMLElement & {readonly value: string}} SecurityCodeElement
 */

/**
 * Each {@link !HTMLInputElement} will be processed.
 * @typedef {import('@acng/frontend-stargazer').TemplateUtility<{}>} Template
 */

/**
 * @implements {SecurityCodeElement}
 */
export class SecurityCode extends Widget {
  /**
   * @param {Template} template
   */
  render(template) {
    const inputs = queryAll(TAGNAME_INPUT, template.content);

    for (let i = 0; i < inputs.length; i++) {
      const el = inputs[i];
      on(el, EVENT_KEYDOWN, function ({code}) {
        if (code === 'Backspace' && this.value === '') {
          inputs[Math.max(0, i - 1)].focus();
        }
      });

      on(el, EVENT_INPUT, function () {
        const [first, ...rest] = this.value;
        this.value = first ?? '';
        const lastInputBox = i === inputs.length - 1;
        const didInsertContent = first !== undefined;
        if (didInsertContent && !lastInputBox) {
          const next = inputs[i + 1];
          next.focus();
          next.value = rest.join('');
          next.dispatchEvent(new InputEvent(EVENT_INPUT));
        }
      });
    }
  }

  connectedCallback() {
    super.connectedCallback();
    query(TAGNAME_INPUT, this)?.focus();
  }

  get value() {
    return [...queryAll(TAGNAME_INPUT, this)].reduce((p, c) => (p += c.value), '');
  }
}

coreFeature.defineWidget('onsw-security-code', SecurityCode);
